<button mat-mini-fab class="close" (click)="$event.stopPropagation(); onClose()">
	<mat-icon>close</mat-icon>
</button>
<div [ngClass]="{'app-light-theme': !themeService.isDark, 'app-dark-theme': themeService.isDark}" fxFlex fxLayout="column" fxLayoutGap="10%" fxLayoutAlign="center center">
	<div fxLayoutAlign="center center" *ngIf="showSpinner">
		<mat-spinner></mat-spinner>
  </div>
	<app-video-player [videoSrc]="videoSrc" [captionSrc]="captionSrc" [videoName]="videoName" [transcriptUrl]="transcriptUrl" [showTranscript]="data.showTranscript" [ngClass]="{'video-player': !showSpinner, 'hide-video': showSpinner}"></app-video-player>
</div>
